export const LOADING_GPSDEVICE = "LOADING_GPSDEVICE";
export const GET_GPSDEVICE_LIST = "GET_GPSDEVICE_LIST";
export const GET_GPSDEVICEBYID = "GET_GPSDEVICEBYID";
export const REMOVE_GPSDEVICE = "REMOVE_GPSDEVICE";
export const ADD_GPSDEVICE = "ADD_GPSDEVICE";
export const UPDATE_GPSDEVICE = "UPDATE_GPSDEVICE";